// extracted by mini-css-extract-plugin
export var container = "ContactPersonList-module--container--5i7j2";
export var link = "ContactPersonList-module--link--6IOEa";
export var title = "ContactPersonList-module--title--MHiDX";